import axios from 'axios'
import type { ApiResponse } from '@/types'
import { API_CONFIG } from '../../config/api'

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  withCredentials: true,
  timeout: API_CONFIG.timeout,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  
  return config
})

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error('API Response Error:', {
      url: error.config?.url,
      message: error.message,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
      timeout: error.code === 'ECONNABORTED'
    })
    
    if (error.response?.status === 401) {
      // 清除認證資料，讓 React Router 處理重定向
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user')
      
      // 如果當前不在登入頁面，才進行重定向
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
export type { ApiResponse }